document.addEventListener('DOMContentLoaded', function() {
    // Sử dụng chính xác class của nút xóa mà bạn cung cấp
    var removeSelector = '.js-remove-item, .cart-item__remove';
    
    function makeLinkSafe(link, e) {
    // 1. Ghi đè URL được kéo thả (Drag Payload) thành URL an toàn
    if (e && e.dataTransfer) {
        var safeUrl = window.location.origin + '/cart';
        e.dataTransfer.setData('text/plain', safeUrl);
        e.dataTransfer.setData('text/uri-list', safeUrl);
    }
    
    // 2. Đổi tạm thời thuộc tính href sang link an toàn
    if (!link.hasAttribute('data-real-href')) {
        link.setAttribute('data-real-href', link.getAttribute('href'));
        link.setAttribute('href', '/cart'); 
    }
    }

    function restoreLink(link) {
    if (link.hasAttribute('data-real-href')) {
        link.setAttribute('href', link.getAttribute('data-real-href'));
        link.removeAttribute('data-real-href');
    }
    }

    // --- XỬ LÝ CHO KÉO THẢ (DRAG) ---
    document.addEventListener('dragstart', function(e) {
    var removeBtn = e.target.closest(removeSelector);
    if (removeBtn) makeLinkSafe(removeBtn, e);
    }, true);

    document.addEventListener('dragend', function(e) {
    var removeBtn = e.target.closest(removeSelector);
    if (removeBtn) restoreLink(removeBtn);
    }, true);

    // --- XỬ LÝ CHO CHUỘT PHẢI & CHUỘT GIỮA ---
    document.addEventListener('mousedown', function(e) {
    if (e.button === 1 || e.button === 2) {
        var removeBtn = e.target.closest(removeSelector);
        if (removeBtn) makeLinkSafe(removeBtn, null);
    }
    }, true);

    document.addEventListener('mouseup', function(e) {
    var removeBtn = e.target.closest(removeSelector);
    if (removeBtn) setTimeout(function() { restoreLink(removeBtn); }, 50);
    }, true);

    document.addEventListener('mouseout', function(e) {
    var removeBtn = e.target.closest(removeSelector);
    if (removeBtn) restoreLink(removeBtn);
    }, true);

});